import {
  PromptKind,
  PromptScope,
} from "@redotech/redo-model/agents/returns-agents/prompts";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const savePrompt = unaryRpc({
  name: "savePrompt",
  input: z.intersection(
    z.object({ promptText: z.string(), kind: createEnum(PromptKind) }),
    z.discriminatedUnion("scope", [
      z.object({ scope: z.literal(PromptScope.DEFAULT) }),
      z.object({ scope: z.literal(PromptScope.USER), userId: zExt.objectId() }),
      z.object({ scope: z.literal(PromptScope.TEAM), teamId: zExt.objectId() }),
    ]),
  ),
  output: z.object({ success: z.boolean() }),
});
